import { useFlyoutV2 } from '@/utils/sharedHooks'
import { Icon, Sheet } from '@/ui'
import { useCallback } from 'react'

export const Flyout = () => {
  const {
    open,
    closeFlyout,
    direction,
    title,
    titleIcon,
    footer,
    description,
    getContent,
    getPreventClose,
  } = useFlyoutV2()

  const handleOpenChange = useCallback(
    (isOpen: boolean) => {
      if (!isOpen && getPreventClose?.()) return
      if (!isOpen) closeFlyout()
    },
    [closeFlyout, getPreventClose]
  )

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <Sheet.Content
        side={direction}
        className="w-full max-w-4xl flex flex-col bg-neutral-0 overflow-hidden p-0"
      >
        {/* Header */}
        <Sheet.Title className="flex items-center gap-2 mb-2">
          {titleIcon && <Icon icon={titleIcon} className="w-4 h-4" />}
          {title}
        </Sheet.Title>
        <Sheet.Description>{description}</Sheet.Description>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">{getContent?.()}</div>

        {/* Footer */}
        {footer && (
          <div className="border-t my-4 border-neutral-200">{footer}</div>
        )}
      </Sheet.Content>
    </Sheet>
  )
}
